/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Split_Ppl_ArmsInputs */

const en_us2_plan_split_ppl_arms = /** @type {(inputs: Plan_Split_Ppl_ArmsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Push · pull · legs · arms`)
};

const pt_br2_plan_split_ppl_arms = /** @type {(inputs: Plan_Split_Ppl_ArmsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empurrar · puxar · pernas · braços`)
};

const es_419_plan_split_ppl_arms = /** @type {(inputs: Plan_Split_Ppl_ArmsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empuje · tirón · piernas · brazos`)
};

const pt_pt2_plan_split_ppl_arms = /** @type {(inputs: Plan_Split_Ppl_ArmsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empurrar · puxar · pernas · braços`)
};

const fr_fr2_plan_split_ppl_arms = /** @type {(inputs: Plan_Split_Ppl_ArmsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poussée · tirage · jambes · bras`)
};

const de_de2_plan_split_ppl_arms = /** @type {(inputs: Plan_Split_Ppl_ArmsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drücken · Ziehen · Beine · Arme`)
};

const it_it2_plan_split_ppl_arms = /** @type {(inputs: Plan_Split_Ppl_ArmsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spinta · tirata · gambe · braccia`)
};

/**
* | output |
* | --- |
* | "Push · pull · legs · arms" |
*
* @param {Plan_Split_Ppl_ArmsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_split_ppl_arms = /** @type {((inputs?: Plan_Split_Ppl_ArmsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Split_Ppl_ArmsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_split_ppl_arms(inputs)
	if (locale === "es-419") return es_419_plan_split_ppl_arms(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_split_ppl_arms(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_split_ppl_arms(inputs)
	if (locale === "de-DE") return de_de2_plan_split_ppl_arms(inputs)
	if (locale === "it-IT") return it_it2_plan_split_ppl_arms(inputs)
	return en_us2_plan_split_ppl_arms(inputs)
});
export { plan_split_ppl_arms as "plan.split.ppl_arms" }